
import { defineComponent, computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import axios from "axios";

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const router = useRouter();
    const i18n = useI18n();
    const store = useStore();
    let userInfo: any = null;
    try {
      userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    } catch (error) {
      userInfo = null;
    }
    const factoryId = ref(null);
    i18n.locale.value = localStorage.getItem("lang")
      ? (localStorage.getItem("lang") as string)
      : "en";

    if (userInfo && userInfo.imageProfile) {
      if (userInfo.imageProfile.indexOf("http") == -1) {
        userInfo.imageProfile =
          process.env.VUE_APP_IMG_URL + userInfo.imageProfile;
      }
    }

    onMounted(async () => {
      if (!localStorage.getItem("id_token")) {
        return;
      }
      try {
        factoryId.value = await axios
          .get(
            process.env.VUE_APP_API_URL +
              "/getProfile?id=" +
              localStorage.getItem("u_id"),
            {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            },
          )
          .then((res) => {
            return res.data.data.specialist && res.data.data.specialist.factoryId ? res.data.data.specialist.factoryId : null;
          });
      } catch (error) {
        // console.log(error);
      }
    });

    const countries = {
      en: {
        flag: "media/flags/united-states.svg",
        name: "English",
      },
      es: {
        flag: "media/flags/spain.svg",
        name: "Spanish",
      },
      de: {
        flag: "media/flags/germany.svg",
        name: "German",
      },
      ja: {
        flag: "media/flags/japan.svg",
        name: "Japanese",
      },
      fr: {
        flag: "media/flags/france.svg",
        name: "French",
      },
    };

    const signOut = () => {
      store.dispatch(Actions.LOGOUT).then(() => router.go(0));
    };

    const setLang = (lang) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const currentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };

    const currentLangugeLocale = computed(() => {
      return countries[i18n.locale.value];
    });

    return {
      signOut,
      setLang,
      currentLanguage,
      currentLangugeLocale,
      countries,
      userInfo,
      factoryId,
    };
  },
  methods: {
    setAltImg(event) {
      event.target.src = "media/avatars/blank.png";
    },
  },
});
